module.exports = __webpack_public_path__ + "1207f4c931f36d363db60d1fe9f30cbe.svg";